import React, { createContext, useState } from "react";

export const CrmContext = createContext();

export const CrmContextProvider = (props) => {
  const [state, setState] = useState({
    tradeId: undefined,
    loading: false,
    updating: false,
    error: undefined,
    trade: undefined,
  });

  return (
    <CrmContext.Provider
      value={{
        ...state,
        setTradeId: (id) => {
          setState({
            tradeId: id,
            loading: true,
            updating: false,
            error: undefined,
            trade: undefined,
          });
        },
        setTrade: (data) =>
          setState({
            ...state,
            loading: false,
            updating: false,
            error: undefined,
            trade: data,
          }),
        unsetTrade: () =>
          setState({
            tradeId: undefined,
            error: undefined,
            updating: false,
            loading: false,
            trade: undefined,
          }),
        setError: (err) => {
          setState({
            ...state,
            error: err,
          });
        },
        updateContacts: (data) =>
          setState({
            ...state,
            trade: {
              ...state.trade,
              contacts: data,
            },
          }),
        insertTask: (task) =>
          setState({
            ...state,
            trade: {
              ...state.trade,
              tasks: [...state.trade.tasks, task],
            },
          }),
        updateTasks: (data) =>
          setState({
            ...state,
            trade: {
              ...state.trade,
              tasks: data,
            },
          }),
        updateComments: (data) =>
          setState({
            ...state,
            trade: {
              ...state.trade,
              comments: data,
            },
          }),
      }}
    >
      {props.children}
    </CrmContext.Provider>
  );
};
